import {
  GET_TERMS_CONDITIONS_LOADING,
  GET_TERMS_CONDITIONS_SUCCESS,
  GET_TERMS_CONDITIONS_ERROR
} from '../actions/types';

const initialState = {
  loading: false,
  error: null,
  success: false,
  unsignedTermsIdList: []
};

export const termsAndConditions = (state = initialState, action) => {
  switch (action.type) {
    case GET_TERMS_CONDITIONS_LOADING:
      return {
        ...state,
        success: false,
        loading: true
      };
    case GET_TERMS_CONDITIONS_SUCCESS:
      return {
        ...state,
        success: true,
        loading: false,
        unsignedTermsIdList: action.payload
      };
    case GET_TERMS_CONDITIONS_ERROR:
      return {
        ...state,
        success: false,
        loading: false,
        error: action.error
      };

    default:
      return state;
  }
};
